<template>
  <base-dialog
    ref="warehousingDialog"
    v-bind="$attrs"
    :dialogVisible="dialogVisible"
    width="500px"
    @handleClose="handleClose"
    @handleConfirm="handleConfirm"
    :show-close="false"
  >
    <template #title
      >{{
        isWarehousing
          ? $t("warehousingAudit.cancelBanke")
          : $t("memoryBankV2.Warehousing")
      }}
    </template>
    <div
      v-show="isWarehousing"
      style="color: #ff6969; margin-bottom: 20px; text-align: center"
    >
      {{
        bankType === "memory"
          ? $t("warehousingAudit.cancelBankeTips")
          : $t("warehousingAudit.cancelBankeTips2")
      }}
    </div>
    <ul  :class="isWarehousing ? 'cancelBanke-body': 'ware-body'">
      <li class="ware-item" :style="{ width: isWarehousing ? '' : '100%' }">
        <span
          class="ware-item_label"
          :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
        >
          {{
            bankType === "memory"
              ? $t("newProjectV2.memoryBankName")
              : $t("newProjectV2.termBankName")
          }}：
        </span>
        <span
          class="ware-item_content"
          v-if="!isWarehousing"
          :style="{
            width: isWarehousing ? '260px' : '',
            flex: isWarehousing ? '' : '1',
          }"
        >
          <el-input
            size="small"
            v-model="infoData.name"
            @blur="handleBlurValidate($event, 'name')"
          >
          </el-input>
        </span>
        <el-tooltip
          v-else
          :disabled="tipsDisabled"
          effect="dark"
          :content="infoData.name"
          placement="top-start"
        >
          <span
            class="ware-item_content"
            @mouseover="mouseOverShowTips($event)"
            :style="{
              width: isWarehousing ? '260px' : '',
              flex: isWarehousing ? '' : '1',
            }"
          >
            {{ infoData.name }}
          </span>
        </el-tooltip>
        <div class="error-message" v-show="message.name">
          {{ message.name }}
        </div>
      </li>
      <li class="ware-item" :style="{ width: isWarehousing ? '' : '100%' }">
        <span
          class="ware-item_label"
          :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
        >
          {{ $t("warehousingAudit.warehousingType") }}：
        </span>
        <span
          class="ware-item_content"
          :style="{
            width: isWarehousing ? '260px' : '',
            flex: isWarehousing ? '' : '1',
          }"
        >
          {{
            bankType === "memory"
              ? $t("newProjectV2.transMemoryBank")
              : $t("newProjectV2.termBank")
          }}
        </span>
      </li>
      <li class="ware-item" :style="{ width: isWarehousing ? '' : '100%' }">
        <span
          class="ware-item_label"
          :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
        >
          {{ $t("newProjectV2.langPair") }}：
        </span>
        <el-tooltip
          :disabled="tipsDisabled"
          effect="dark"
          :content="
            $i18n.locale === 'zh'
              ? infoData.langDesc.replace('>', ' — ')
              : getEnlang(infoData.sourceLang, infoData.targetLang)
          "
          placement="top-start"
        >
          <span
            class="ware-item_content"
            @mouseover="mouseOverShowTips($event)"
            :style="{
              width: isWarehousing ? '260px' : '',
              flex: isWarehousing ? '' : '1',
            }"
          >
            {{
              $i18n.locale === "zh"
                ? infoData.langDesc.replace(">", " — ")
                : getEnlang(infoData.sourceLang, infoData.targetLang)
            }}
          </span>
        </el-tooltip>
      </li>
      <li class="ware-item" :style="{ width: isWarehousing ? '' : '100%' }">
        <span
          class="ware-item_label"
          :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
        >
          {{ $t("newProjectV2.domain") }}：
        </span>
        <span
          class="ware-item_content"
          :style="{
            width: isWarehousing ? '260px' : '',
            flex: isWarehousing ? '' : '1',
          }"
        >
          {{
            $i18n.locale === "zh"
              ? infoData.domainName
              : getEnDomain(infoData.domainCode)
          }}
        </span>
      </li>
      <li class="ware-item" :style="{ width: isWarehousing ? '' : '100%' }">
        <el-tooltip
          :disabled="$i18n.locale === 'zh'"
          effect="dark"
          :content="$t('warehousingAudit.submittedSentNum')"
          placement="top-start"
        >
          <span
            class="ware-item_label"
            :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
          >
            {{ $t("warehousingAudit.submittedSentNum") }}：
          </span>
        </el-tooltip>
        <span
          class="ware-item_content"
          :style="{
            width: isWarehousing ? '260px' : '',
            flex: isWarehousing ? '' : '1',
          }"
        >
          {{ infoData.notStockCount }}
        </span>
      </li>
      <li
        class="ware-item ware-item_remark"
        :class="{ 'notWare-item_remark': isWarehousing }"
        :style="{ width: isWarehousing ? '' : '100%' }"
      >
        <span
          class="ware-item_label remark-label"
          :style="{ width: $i18n.locale === 'zh' ? '100px' : '170px' }"
        >
          {{ $t("newProjectV2.remark") }}：
        </span>
        <span
          class="ware-item_content"
          v-if="!isWarehousing"
          :style="{
            width: isWarehousing ? '260px' : '',
            flex: isWarehousing ? '' : '1',
          }"
        >
          <el-input
            type="textarea"
            resize="none"
            v-model="infoData.remark"
            :placeholder="$t('memoryBankV2.pleaseInputRemark')"
            @blur="handleBlurValidate($event, 'remark')"
          >
          </el-input>
        </span>
        <el-tooltip
          v-else
          :disabled="tipsDisabled"
          effect="dark"
          :content="infoData.remark"
          placement="top-start"
        >
          <span
            class="ware-item_content"
            @mouseover="mouseOverShowTips($event)"
            :style="{
              width: isWarehousing ? '260px' : '',
              flex: isWarehousing ? '' : '1',
            }"
          >
            {{ infoData.remark }}
          </span>
        </el-tooltip>
        <div class="error-message" v-show="message.remark">
          {{ message.remark }}
        </div>
      </li>
    </ul>
    <template #confirm>{{ $t("common.submit") }}</template>
    <template #footer-text>
      <div class="footer-text" v-if="!isWarehousing">
        提交后管理员将进行审核，审核通过后即可纳入公共库，查看审核结果，请进入<span @click="toWarehousingAudit">入库记录></span>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex';
import ExceedTips from "../../../mixins/ExceedTips";
export default {
  name: "WarehousingDialog",
  mixins: [ExceedTips],
  props: {
    isWarehousing: {
      type: Boolean,
      default: false,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    bankType: {
      type: String,
      default: "",
    },
    corpusDetailInfo: {
      type: Object,
      default: () => {},
    },
    isFirst:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      infoData: {
        name: "",
        remark: "",
        langDesc: "",
        domainName: "",
        domainCode: "",
        sourceLang: "",
        targetLang: "",
        notStockCount: 0,
        id: "",
      },
      message: {
        name: "",
        remark: "",
      },
    };
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          for (const key in this.infoData) {
            if (Object.hasOwnProperty.call(this.corpusDetailInfo, key)) {
              this.infoData[key] = this.corpusDetailInfo[key];
            }
          }
          if(this.isFirst == true){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); 
            const day = currentDate.getDate().toString().padStart(2, '0');
            
            this.infoData.name = `${this.userInfo.departName}_${year}${month}${day}_${this.userInfo.nickName}`;
          }
        });
      }
    },
  },
  computed:{
    ...mapState({
      userInfo: state => state.layout.userInfo,
    }),
  },
  methods: {
    // 去入库记录
    toWarehousingAudit(){
      this.$router.push({
        name:'warehousingAudit'
      })
    },
    handleClose() {
      this.$emit("handleClose");
      this.clearValidate();
    },

    async handleConfirm() {
      //验证数据 如果是入库
      if (!this.isWarehousing) {
        const { name, remark } = this.infoData;
        let validName = false;
        let validRemark = false;
        if (name === "") {
          this.message.name = this.$t("termBankV2.pleaseInputActivity");
          validName = false;
        } else if (name.length > 50) {
          this.message.name = this.$t("termBankV2.WithinSixteenLength");
          validName = false;
        } else {
          this.message.name = "";
          validName = true;
        }
        if (remark.length > 140) {
          this.message.remark = this.$t("termBankV2.WithinFiftyLength", [140]);
          validRemark = false;
        } else {
          this.message.remark = "";
          validRemark = true;
        }
        if (validRemark && validName) {
          this.$emit("handleConfirm", { ...this.infoData });
          this.clearValidate();
        }
      } else {
        // 取消入库
        this.$emit("handleConfirm", { ...this.infoData });
        this.clearValidate();
      }
    },

    clearValidate() {
      for (const key in this.message) {
        this.message[key] = "";
      }
    },
    // 验证
    handleBlurValidate(event, type) {
      const value = event.target.value;
      switch (type) {
        case "name":
          if (value === "") {
            this.message.name = this.$t("termBankV2.pleaseInputActivity");
          } else if (value.length > 50) {
            this.message.name = this.$t("termBankV2.WithinSixteenLength");
          } else {
            this.message.name = "";
          }
          break;
        case "remark":
          if (value.length > 140) {
            this.message.remark = this.$t("termBankV2.WithinFiftyLength", [
              140,
            ]);
          } else {
            this.message.remark = "";
          }
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0 30px;
  .ware-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .ware-item + .ware-item {
      margin-top: 12px;
    }
    .ware-item {
      position: relative;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      // width: 100%;
      &_label {
        width: 100px;
        text-align: left;
        color: #303133;
        font-size: 14px;
        font-weight: bolder;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &_content {
        // flex: 1;
        color: #606266;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 14px;
        padding-left: 8px;
        .el-textarea {
          width: 400px;
        }
        .el-input {
          width: 400px;
        }
      }
      .error-message {
        position: absolute;
        bottom: -16px;
        left: 10px;
        color: #f56c6c;
        font-size: 12px;
      }
    }
    .ware-item_remark {
      // .remark-label {
      //   height: 130px;
      // }
      .el-textarea__inner {
        height: 130px;
      }
    }
    .notWare-item_remark {
      .remark-label {
        height: auto !important;
      }

      .el-textarea__inner {
        height: auto !important;
      }
    }
  }
  .cancelBanke-body{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .ware-item + .ware-item {
      margin-top: 12px;
    }
    .ware-item {
      position: relative;
      display: flex;
      align-items: center;
      // width: 100%;
      &_label {
        width: 100px;
        text-align: right;
        color: #909399;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &_content {
        // flex: 1;
        color: #303133;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .error-message {
        position: absolute;
        bottom: -16px;
        left: 10px;
        color: #f56c6c;
        font-size: 12px;
      }
    }
    .ware-item_remark {
      .remark-label {
        height: 130px;
      }
    }
    .notWare-item_remark {
      .remark-label {
        height: auto !important;
      }

      .el-textarea__inner {
        height: auto !important;
      }
    }
  }
}
/deep/.el-dialog__footer {
  padding: 30px;
}
.footer-text{
  margin-top: 20px;
  padding: 0 20px;
  color:#909399;
  font-size: 14px;
  text-align: left;
  span{
    color: #0078FC;
    cursor: pointer;
  }
}
</style>